import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getFilteredAccounts } from '../../../../sections/AccountListNew/accountListUtils';

const useWatchList = () => {
  const navigate = useNavigate();
  const accountList = useSelector((state) => state.accountsWithLicenseList?.data);
  const siteConfiguration = useSelector((state) => state.siteConfiguration?.data);
  const featureUsageAccounts = useSelector((state) => state.featureUsageAccounts?.data);
  const customFilterViewList = useSelector((state) => state.customFilterView?.data);
  const filteredItems = useMemo(() => customFilterViewList?.filter((item) => item.alert), [customFilterViewList]);

  const handleClick = (id) => {
    navigate(`/account-list/${id}`);
  };

  const [watchListData, setWatchListData] = useState([]);

  useEffect(() => {
    if (!filteredItems?.length) {
      setWatchListData([]);
      return;
    }

    // Set initial loading state
    setWatchListData(
      filteredItems.map((item) => ({
        id: item.id,
        text: item.name,
        count: 0,
        onClick: () => handleClick(item.id),
      })),
    );

    // Async fetch and update counts
    const fetchCounts = async () => {
      const updatedData = await Promise.all(
        filteredItems.map(async (item) => {
          const filtered = await getFilteredAccounts({
            accountList,
            selectedFilters: item.filter,
            siteConfiguration,
            featureUsageAccounts,
            isNavigatedFromRiskAccount: false,
          });

          return {
            id: item.id,
            text: item.name,
            count: filtered?.length ?? 0,
            onClick: () => handleClick(item.id),
          };
        }),
      );

      setWatchListData(updatedData);
    };

    fetchCounts();
  }, [filteredItems, accountList, siteConfiguration, featureUsageAccounts]);

  return { watchListData, filteredItems };
};

export default useWatchList;
